import { useState , useContext,useEffect} from "react";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { BsArrowRightSquareFill } from "react-icons/bs";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import '../../styles/filterComponents.css';

/**
 * The RefineSearch component is a collapsible RefineSearch that contains a title, a toggle button, and a content
 * area for children components.
 * @returns a JSX element.
 */
export default function Sidebar({children , menu}) {
    // const [open, setOpen] = useState(false);
    const {dropdown,setDropdown,isMobile,setIsMobile,open, setOpen} = useContext(PeFilterContext);
    
    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    const handleToggle = () => {
        setDropdown(!dropdown);
        console.log(dropdown , "jgjhg")
    };
    
    useEffect(()=>{
        if (window.innerWidth < 800) {
            // setOpen(true);
            setIsMobile(true);
        }    },[])

    return (
        <>
        <div className="relative">
            {/* Filter Modal */}
            {open && (
                <div className="filter-modal">
                    <div className="filter-modal-content no-scrollbar" style={{overflowY: "auto"}}>
                        {/* Header */}
                        <div className="flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-[#BC8B20] flex items-center">
                                <span className="font-bold text-[16px] ml-1">Filters</span>
                            </h2>
                            <button type="button" onClick={() => setOpen(false)} className="text-gray-500 hover:text-gray-700">
                                <IoClose size={24} />
                            </button>
                        </div>

                        {/* Filters Grid Layout */}
                        <div className={`filter-grid ${dropdown || menu === "ioc" ? '' : 'hidden'}`}>
                            {children}
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end space-x-4 mt-4">
                            <button 
                                type="button"
                                onClick={() => {
                                    // This will trigger the reset in the form
                                    const form = document.querySelector('form');
                                    if (form) form.reset();
                                }}
                                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                            >
                                Reset
                            </button>
                            <button 
                                type="button"
                                onClick={() => {
                                    // requestSubmit triggers HTML5 validation before firing onSubmit;
                                    // if validation fails the modal stays open automatically.
                                    const form = document.querySelector('form');
                                    if (form) form.requestSubmit();
                                }}
                                className="px-4 py-2 bg-[#bc8b20] text-white rounded-md hover:bg-[#a67a1b]"
                            >
                                Filter
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </>
    );
}